// Copyright 2026, University of Maryland, All Rights Reserved
import { Check } from 'lucide-react'

export function NewAgentProgress({ step }: { step: 1 | 2 }) {
  return (
    <div className="flex items-center gap-2 text-[13px]" aria-label={`Step ${step} of 2`}>
      <span className={`flex items-center gap-1.5 ${step === 2 ? 'text-emerald-700' : 'text-slate-900'}`}>
        <span className={`flex size-5 items-center justify-center rounded-full text-[11px] font-semibold ${step === 2 ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-900 text-white'}`}>
          {step === 2 ? <Check className="size-3" strokeWidth={2.5} /> : '1'}
        </span>
        Choose type
      </span>
      <span className="h-px w-7 bg-slate-200" />
      <span className={`flex items-center gap-1.5 ${step === 2 ? 'text-slate-900' : 'text-slate-400'}`}>
        <span className={`flex size-5 items-center justify-center rounded-full text-[11px] font-semibold ${step === 2 ? 'bg-slate-900 text-white' : 'border border-slate-200 text-slate-400'}`}>
          2
        </span>
        Configure
      </span>
    </div>
  )
}
